<template>
  <svg
    width="208"
    height="172"
    viewBox="0 0 104 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.9936 0H17.2007C7.70103 0 0 7.70103 0 17.2007V68.7928C0 78.2925 7.70103 85.9936 17.2007 85.9936H85.9936C95.4933 85.9936 103.194 78.2925 103.194 68.7928V17.2007C103.194 7.70103 95.4933 0 85.9936 0Z"
      fill="#0B132B"
    />
    <g style="mix-blend-mode:hard-light">
      <path
        d="M103.194 17.1906L93.2424 19.671C66.4744 26.1706 39.3217 32.6804 13.0094 38.9877C8.66617 40.0304 4.32296 41.0732 0 42.1059V17.1906C0 7.68414 7.70439 0 17.2109 0H86.0037C95.5101 0 103.194 7.69427 103.194 17.1906Z"
        fill="url(#paint0_linear_9_1001)"
      />
    </g>
    <path
      d="M85.3101 21.8076C85.9066 21.9674 86.5732 21.9049 87.1462 21.5659C88.3117 20.8929 88.7074 19.4163 88.0344 18.2508C85.3785 13.6506 81.1175 10.3078 76.0221 8.82721C74.7665 8.42789 73.3883 9.19056 73.0104 10.4833C72.6352 11.7663 73.3738 13.1171 74.6666 13.495C78.5546 14.6311 81.8123 17.181 83.8284 20.6874C84.1649 21.2701 84.7012 21.6549 85.3075 21.8173L85.3101 21.8076Z"
      fill="#4CE0B3"
    />
    <path
      d="M16.9657 21.8076C16.3692 21.9674 15.7026 21.905 15.1296 21.5659C13.9641 20.8929 13.5684 19.4163 14.2413 18.2508C16.8972 13.6506 21.1583 10.3078 26.2537 8.82721C27.5092 8.42789 28.8875 9.19056 29.2653 10.4833C29.6405 11.7663 28.902 13.1171 27.6092 13.495C23.7212 14.6311 20.4635 17.181 18.4473 20.6874C18.1109 21.2701 17.5746 21.6549 16.9683 21.8174L16.9657 21.8076Z"
      fill="#4CE0B3"
    />
    <path
      d="M33.5712 48.3447C39.2687 48.3447 43.8875 43.7259 43.8875 38.0283C43.8875 32.3307 39.2687 27.7119 33.5712 27.7119C27.8736 27.7119 23.2548 32.3307 23.2548 38.0283C23.2548 43.7259 27.8736 48.3447 33.5712 48.3447Z"
      fill="#4CE0B3"
    />
    <path
      d="M69.633 48.4467C75.3306 48.4467 79.9494 43.8279 79.9494 38.1304C79.9494 32.4328 75.3306 27.814 69.633 27.814C63.9355 27.814 59.3167 32.4328 59.3167 38.1304C59.3167 43.8279 63.9355 48.4467 69.633 48.4467Z"
      fill="#4CE0B3"
    />
    <path
      d="M33.5712 43.1927C36.4228 43.1927 38.7345 40.8811 38.7345 38.0295C38.7345 35.1779 36.4228 32.8662 33.5712 32.8662C30.7196 32.8662 28.408 35.1779 28.408 38.0295C28.408 40.8811 30.7196 43.1927 33.5712 43.1927Z"
      fill="#A6F4D8"
    />
    <path
      d="M69.6331 43.2936C72.4847 43.2936 74.7964 40.9819 74.7964 38.1303C74.7964 35.2787 72.4847 32.967 69.6331 32.967C66.7815 32.967 64.4698 35.2787 64.4698 38.1303C64.4698 40.9819 66.7815 43.2936 69.6331 43.2936Z"
      fill="#A6F4D8"
    />
    <g style="mix-blend-mode:screen">
      <path
        style="mix-blend-mode:screen"
        opacity="0.68"
        d="M16.8157 37.7858C16.9372 24.8574 24.5403 14.4094 33.7937 14.4398C43.0471 14.4803 50.4477 24.989 50.3262 37.9275C50.2047 50.8559 42.6016 61.3039 33.3482 61.2736C24.0949 61.2331 16.6942 50.7243 16.8157 37.7858Z"
        fill="url(#paint1_radial_9_1001)"
      />
    </g>
    <g style="mix-blend-mode:screen">
      <path
        style="mix-blend-mode:screen"
        opacity="0.68"
        d="M53.2626 37.7855C53.3841 24.8572 60.9872 14.4091 70.2406 14.4395C79.494 14.48 86.8946 24.9888 86.7731 37.9273C86.6516 50.8557 79.0485 61.3037 69.7951 61.2733C60.5418 61.2328 53.1411 50.7241 53.2626 37.7855Z"
        fill="url(#paint2_radial_9_1001)"
      />
    </g>
    <path
      d="M85.9936 2.42977C94.1434 2.42977 100.765 9.06101 100.765 17.2007V68.8029C100.765 76.9528 94.1333 83.5739 85.9936 83.5739H17.2007C9.05088 83.5739 2.42976 76.9427 2.42976 68.8029V17.2007C2.42976 9.05089 9.06101 2.42977 17.2007 2.42977H85.9936ZM85.9936 0H17.2007C7.70439 0 0 7.70439 0 17.2007V68.8029C0 78.2993 7.70439 86.0037 17.2007 86.0037H85.9936C95.4899 86.0037 103.194 78.2993 103.194 68.8029V17.2007C103.194 7.70439 95.5 0 85.9936 0Z"
      fill="#0B132B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9_1001"
        x1="125.012"
        y1="-14.9633"
        x2="18.5675"
        y2="22.8601"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2853E1" />
        <stop
          offset="1"
          stop-color="#2853E1"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint1_radial_9_1001"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.6114 37.5836) rotate(-180) scale(16.1985 15.7588)"
      >
        <stop stop-color="#4CE0B3" />
        <stop
          offset="1"
          stop-color="#4CE0B3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9_1001"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(70.0583 37.5834) rotate(-180) scale(16.1985 15.7588)"
      >
        <stop stop-color="#4CE0B3" />
        <stop
          offset="1"
          stop-color="#4CE0B3"
          stop-opacity="0"
        />
      </radialGradient>
    </defs>
  </svg>
</template>
